/**
 * sizeGuideDrawer — Alpine.js component
 *
 * Controls the Size Guide drawer that slides in from the right.
 * Responds to the 'size-guide:toggle' window event dispatched by
 * the runSizeGuideToggle action (arc:action:sizeGuideToggle).
 *
 * Trigger from a button-link block:
 *   Action Preset: Custom
 *   Custom Event IDs: sizeGuideToggle
 *
 * @param {string} initialRegion - Region code to select on open (from Liquid current_region)
 */

export default {
  name: 'sizeGuideDrawer',
  component(initialRegion = '') {
    return {
      isOpen: false,
      activeTab: 'measurements',
      selectedRegion: initialRegion,
      unit: 'cm',

      init() {
        this._toggleHandler = () => this.toggle();
        this._openHandler   = () => this.open();
        this._closeHandler  = () => this.close();

        window.addEventListener('size-guide:toggle', this._toggleHandler);
        window.addEventListener('size-guide:open',   this._openHandler);
        window.addEventListener('size-guide:close',  this._closeHandler);

        this._keyHandler = (e) => {
          if (e.key === 'Escape' && this.isOpen) this.close();
        };
        document.addEventListener('keydown', this._keyHandler);
      },

      destroy() {
        window.removeEventListener('size-guide:toggle', this._toggleHandler);
        window.removeEventListener('size-guide:open',   this._openHandler);
        window.removeEventListener('size-guide:close',  this._closeHandler);
        document.removeEventListener('keydown', this._keyHandler);
        document.body.style.overflow = '';
      },

      open() {
        this.isOpen = true;
        document.body.style.overflow = 'hidden';
      },

      close() {
        this.isOpen = false;
        document.body.style.overflow = '';
      },

      toggle() {
        this.isOpen ? this.close() : this.open();
      },
    };
  },
};
